import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
@Component({
  selector: 'app-available-soon',
  standalone: true,
  imports: [TranslateModule, BreadcrumbComponent],
  templateUrl: './available-soon.component.html',
  styleUrl: './available-soon.component.scss',
})
export class AvailableSoonComponent {}
